import { toHex, } from 'viem';
import {} from 'viem/zksync';
import { replaceBigInts } from '../replaceBigInts.js';
export async function sendPrivyTransaction(client, parameters) {
    const result = (await client.request({
        method: 'privy_sendSmartWalletTx',
        params: [replaceBigInts(parameters, toHex)],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }, { retryCount: 0 }));
    return result;
}
export async function sendPrivySignMessage(client, parameters) {
    const result = (await client.request({
        method: 'privy_signSmartWalletMessage',
        params: [parameters.message],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }, { retryCount: 0 }));
    return result;
}
export async function sendPrivySignTypedData(client, parameters) {
    const result = (await client.request({
        method: 'privy_signSmartWalletTypedData',
        params: [client.account.address, parameters],
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }, { retryCount: 0 }));
    return result;
}
//# sourceMappingURL=sendPrivyTransaction.js.map